import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "creditCard"
const CreditCardIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M18.75 15.364H15.75V13.114H18.75z" />
          <path
            fillRule="evenodd"
            d="M20.25 3.75C21.078 3.75 21.75 4.422 21.75 5.25V17.25L21.742 17.403C21.67 18.11 21.109 18.67 20.403 18.742L20.25 18.75H3.75L3.597 18.742C2.89 18.67 2.33 18.109 2.258 17.403L2.25 17.25V5.25C2.25 4.422 2.922 3.75 3.75 3.75zM3.75 17.25H20.25V9.75H3.75zM3.75 8.25H20.25V5.25H3.75z"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default CreditCardIcon
